import React from 'react';
import PropTypes from 'prop-types';

export default class InputSelectOption extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		value: PropTypes.node,
	};

	render() {
		return <option value={this.props.value}>{this.props.name}</option>;
	}
}
